module.exports = __webpack_public_path__ + "img/boybanner.f924df46.png";